module.exports = __webpack_public_path__ + "img/no-content.663577b1.png";